import {
  ChartArea,
  Gauge,
  GitCompareArrows,
  Grid2X2,
  HeartHandshake,
  House,
  LayoutGrid,
  MousePointerClick,
  Plug,
  Settings as SettingsLucide,
  ShieldUser,
  Store,
  TabletSmartphone,
  Tag,
  TestTubeDiagonal,
} from "lucide-react";
import React from "react";

import { HomeDashboard } from "@src/domains/HomeDashboard";
import { AgenciesRoute } from "@src/features/admin/pages/agencies/Agencies.route";
import { AdminOverviewRoute } from "@src/features/admin/pages/overview/AdminOverview.route";
import { SitewideAnalyticsRoute } from "@src/features/analytics/sitewideAnalytics/SitewideAnalytics.route";
import { EventsManagerRoute } from "@src/features/eventsManager/EventsManager.route";
import { ExperiencesHomeRoute } from "@src/features/experiments/pages/home/ExperiencesHome.route";
import { OffersRoute } from "@src/features/offers/Offers.route";
import { SiteContentRoute } from "@src/features/siteContent/SiteContent.route";
import type { MainRoute } from "@src/types/navigation";

import { ConfigCompareDomain } from "../../domains/ConfigCompare";
import { PerformanceRoute } from "../../domains/Performance/PerformanceRoute";
import { Settings } from "../../domains/Settings";
import { IntegrationsRoute } from "../../domains/Settings/Integrations";
import { WidgetLibraryRoute } from "../../domains/WidgetLibrary/WidgetLibrary.route";
import { ExperiencesRoute } from "../../features/personalizations/pages/personalizationOverview/Experiences.route";
import {
  ADMIN_ROUTES,
  EXPERIENCE_ROUTES,
  EXPERIMENT_ROUTES,
  GENERAL_ROUTES,
  GLOBAL_STYLES_ROUTES,
  PERSONALIZATION_ROUTES,
  SETTINGS_ROUTES,
  WIDGET_ROUTES,
} from "../../routes/routes";
interface AdminTpoSideNavRoute {
  overview: MainRoute;
  agency: MainRoute;
}
interface StandardSideNavRoute {
  home: MainRoute;
  experiments: MainRoute;
  sitewideAnalytics: MainRoute;
  widgetLibrary: MainRoute;
  personalizations: MainRoute;
  eventsManager: MainRoute;
  integrations: MainRoute;
  settings: MainRoute;
  experiences: MainRoute;
}

interface BottomSideNavRoute {
  admin: MainRoute;
  configCompare: MainRoute;
  performance: MainRoute;
}

// eslint-disable-next-line react-refresh/only-export-components
export const BillingRoutes: AdminTpoSideNavRoute = {
  overview: {
    path: ADMIN_ROUTES.AdminOverview,
    sidebarName: "Organizations",
    component: <AdminOverviewRoute />,
    icon: <Store size={16} />,
  },
  agency: {
    path: ADMIN_ROUTES.Agencies,
    sidebarName: "Agencies",
    component: <AgenciesRoute />,
    icon: <HeartHandshake size={16} />,
  },
};

export const StandardRoutes = (): StandardSideNavRoute => ({
  home: {
    path: GENERAL_ROUTES.Index,
    sidebarName: "Home",
    component: <HomeDashboard />,
    icon: <House size={16} />,
  },
  experiments: {
    path: EXPERIMENT_ROUTES.Experiments,
    sidebarName: "Tests",
    component: <ExperiencesHomeRoute />,
    icon: <TestTubeDiagonal size={16} />,
  },
  experiences: {
    sidebarName: "Experiences",
    path: EXPERIENCE_ROUTES.Experiences,
    component: <ExperiencesRoute />,
    icon: <TabletSmartphone size={16} />,
    subRoutes: [
      {
        path: EXPERIENCE_ROUTES.Experiences_SiteContent,
        sidebarName: "Site Content",
        component: <SiteContentRoute />,
        icon: <Grid2X2 size={16} />,
      },
      {
        path: EXPERIENCE_ROUTES.Experiences_Offers,
        sidebarName: "Offers",
        component: <OffersRoute />,
        icon: <Tag size={16} />,
      },
    ],
  },
  // personalizations: {
  //   path: PERSONALIZATION_ROUTES.Personalizations,
  //   sidebarName: "Personalizations",
  //   component: <PersonalizationOverviewRoute />,
  //   icon: <TabletSmartphone size={16} />,
  // },
  sitewideAnalytics: {
    path: GENERAL_ROUTES.SitewideAnalytics,
    sidebarName: "Sitewide Analytics",
    component: <SitewideAnalyticsRoute />,
    icon: <ChartArea size={16} />,
  },
  eventsManager: {
    path: GENERAL_ROUTES.EventsManager,
    sidebarName: "Events Manager",
    component: <EventsManagerRoute />,
    icon: <MousePointerClick size={16} />,
  },
  widgetLibrary: {
    path: GLOBAL_STYLES_ROUTES.GlobalStyles_Experiences,
    sidebarName: "Global Styles",
    component: <WidgetLibraryRoute />,
    icon: <LayoutGrid size={16} />,
  },
  integrations: {
    path: GENERAL_ROUTES.Integrations,
    sidebarName: "Integrations",
    // @ts-ignore
    component: IntegrationsRoute,
    icon: <Plug size={16} />,
  },
  settings: {
    path: SETTINGS_ROUTES.Settings,
    sidebarName: "Settings",
    component: <Settings />,
    icon: <SettingsLucide size={16} />,
  },
});

export const AdminRoutes = (): BottomSideNavRoute => ({
  admin: {
    path: ADMIN_ROUTES.AdminOverview,
    sidebarName: "Billing",
    component: <AdminOverviewRoute />,
    icon: <ShieldUser size={16} />,
  },
  configCompare: {
    path: GENERAL_ROUTES.ConfigCompare,
    sidebarName: "Config Compare",
    component: <ConfigCompareDomain />,
    icon: <GitCompareArrows size={16} />,
  },
  performance: {
    path: GENERAL_ROUTES.Performance,
    sidebarName: "Performance",
    // @ts-ignore
    component: PerformanceRoute,
    icon: <Gauge size={16} />,
  },
});
